(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["media"] && !Shopify.designMode) return;
  try {
    // Auto-play video when it becomes the active slide
document.addEventListener('DOMContentLoaded', function() {
  // Show appropriate video version based on device
  function showCorrectVideoVersion() {
    const isMobile = window.innerWidth <= 768;
    const videoWrappers = document.querySelectorAll('.video-wrapper');
    
    videoWrappers.forEach(wrapper => {
      const desktopVideo = wrapper.querySelector('.video-desktop');
      const mobileVideo = wrapper.querySelector('.video-mobile');
      
      if (isMobile) {
        if (desktopVideo) desktopVideo.style.display = 'none';
        if (mobileVideo) mobileVideo.style.display = 'block';
      } else {
        if (mobileVideo) mobileVideo.style.display = 'none';
        if (desktopVideo) desktopVideo.style.display = 'block';
      }
    });
  }
  
  // Initial setup
  showCorrectVideoVersion();
  
  // Update on window resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(showCorrectVideoVersion, 250);
  });
  // Listen for Slick slider events
  const productSlideshow = document.querySelector('.product-slideshow');
  if (productSlideshow && window.jQuery) {
    window.jQuery(productSlideshow).on('afterChange', function(event, slick, currentSlide) {
      // Get the current slide element
      const currentSlideElement = slick.$slides[currentSlide];
      const videoMedia = currentSlideElement.querySelector('.product-media--video');
      
      if (videoMedia) {
        // Show correct video version first
        showCorrectVideoVersion();
        
        // Auto-play video when it becomes active
        setTimeout(() => {
          const playButton = videoMedia.querySelector('.product-media__video-play-btn');
          if (playButton) {
            playButton.click();
          }
        }, 300); // Small delay to ensure slide transition is complete
      }
      
      // Pause videos in other slides
      slick.$slides.each(function(index) {
        if (index !== currentSlide) {
          const otherVideoMedia = this.querySelector('.product-media--video');
          if (otherVideoMedia) {
            // Try to pause any active videos
            const iframe = otherVideoMedia.querySelector('iframe');
            const video = otherVideoMedia.querySelector('video');
            
            if (iframe) {
              // For YouTube/Vimeo iframes, we can try to pause via postMessage
              try {
                if (iframe.src.includes('youtube')) {
                  iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                } else if (iframe.src.includes('vimeo')) {
                  iframe.contentWindow.postMessage('{"method":"pause"}', '*');
                }
              } catch (e) {
                console.log('Could not pause external video:', e);
              }
            }
            
            if (video) {
              video.pause();
            }
          }
        }
      });
    });
    
    // Also trigger autoplay for the initial slide if it's a video
    window.jQuery(productSlideshow).on('init', function(event, slick) {
      const initialSlide = slick.$slides[slick.currentSlide];
      const videoMedia = initialSlide.querySelector('.product-media--video');
      
      if (videoMedia) {
        // Show correct video version first
        showCorrectVideoVersion();
        
        setTimeout(() => {
          const playButton = videoMedia.querySelector('.product-media__video-play-btn');
          if (playButton) {
            playButton.click();
          }
        }, 500); // Longer delay for initial load
      }
    });
  }
});
  } catch(e) { console.error(e); }
})();

})();
